import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './Fatcs.styles'
import { Grid, Icon, Tooltip } from 'components/atoms'
import { TabBar } from '../index'
// import { useSelector } from 'react-redux'

/**
 * @returns {*}
 * @constructor
 */
const Facts = ({ items }) => {
  // const staticAssetPath = useSelector(
  //   (state) => state.application.staticAssetPath
  // )
  const [selectedData, setSelectedData] = useState(items[0])

  const handleTabSelect = (id) => {
    // get department data by id
    const result = items.filter(({ hospitalId }) => hospitalId === id)

    if (result.length > 0) {
      setSelectedData(result[0])
    }
  }

  const getTableHead = (data, index) => (
    <thead key={ index }>
      <tr>
        <th colSpan={ '2' }>{data}</th>
      </tr>
    </thead>
  )

  const getTableBody = (rows, index) => (
    <tbody key={ index }>
      {rows.map((row, index) => (
        <tr key={ index }>
          <td>{row.key}</td>
          <td>
            {row.value}
            {row.tooltip && (
              <span className={ 'tooltip-container' }>
                <Tooltip
                  infoIconId={ 'info-icon' }
                  tooltipId={ 'accordion-header-tooltip' }
                  dialogTitle={ row.key }>
                  {row.tooltip}
                </Tooltip>
              </span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  )

  const getTableContent = (data, index) => {
    const { title, table } = data

    return (
      <div className={ 'table-content' } key={ index }>
        {title && (
          <p className={ 'title' }>
            <b>{title}</b>
          </p>
        )}
        <table>
          {Object.keys(table).map((key, index) => {
            const data = table[key]
            return key === 'head'
              ? getTableHead(data, index)
              : getTableBody(data, index)
          })}
        </table>
      </div>
    )
  }

  const getContactContent = (data, index) => {
    const { title, subTitle, imageUrl, imageTitle, phone, fax, email } = data

    return (
      <div className={ 'contact-content' } key={ index }>
        {title ? (
          <p className={ 'title' }>
            <b>{title}</b>
          </p>
        ) : (
          <p className={ 'title' }>
            <b>Ärztliche Leitung</b>
          </p>
        )}
        {subTitle && <p className={ 'sub-title' }>Seit {subTitle}</p>}
        {imageUrl && (
          <div className={ 'image-container' }>
            {/* <img src={ imageUrl } alt={ imageTitle ? imageTitle : '' }/>*/}
            <img
              // src={`${staticAssetPath}${imageUrl} `}
              src={ imageUrl }
              alt={ imageTitle ? imageTitle : '' }
            />
          </div>
        )}
        {imageTitle && <p className={ 'image-title' }>{imageTitle}</p>}

        {phone && (
          <p className={ 'contact-item' }>
            <span className={ 'contact-icon' }>
              <Icon className='icon-f-phone-handset' />
            </span>
            <a href={ `tel:${ phone }` }>{phone}</a>
          </p>
        )}

        {fax && (
          <p className={ 'contact-item' }>
            <span className={ 'contact-icon' }>
              <Icon className='icon-f-printer' />
            </span>
            {fax}
          </p>
        )}

        {email && (
          <p className={ 'contact-item' }>
            <span className={ 'contact-icon' }>
              <Icon className='icon-f-envelope' />
            </span>
            <a
              href={ `mailto:${ email }` }
              target='_blank'
              rel='noopener noreferrer'>
              {email}
            </a>
          </p>
        )}
      </div>
    )
  }

  return (
    <Styled.FactsComponent>
      <Grid container>
        <Grid item xs={ 12 } md={ 4 }>
          <TabBar
            data={ items }
            onTabSelect={ handleTabSelect }
            selectedId={ selectedData.hospitalId }
          />
        </Grid>
        <Grid item xs={ 12 } md={ 8 }>
          <div className={ 'content-container' }>
            {selectedData?.infos && (
              <>
                {Array.isArray(selectedData.infos) &&
                  selectedData.infos.length > 0 &&
                  selectedData.infos.map((itemData, index) =>
                    itemData.table
                      ? getTableContent(itemData, index)
                      : getContactContent(itemData, index)
                  )}

                {!Array.isArray(selectedData.infos) &&
                  Object.keys(selectedData.infos).length > 0 &&
                  Object.entries(selectedData.infos).map(([key, itemData]) =>
                    itemData.table
                      ? getTableContent(itemData, key)
                      : getContactContent(itemData, key)
                  )}
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </Styled.FactsComponent>
  )
}

Facts.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      hospitalId: PropTypes.string,
      name: PropTypes.string,
      treatments: PropTypes.shape({
        cases: PropTypes.number,
      }),
      infos: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            subTitle: PropTypes.string,
            imageUrl: PropTypes.string,
            imageTitle: PropTypes.string,
            phone: PropTypes.string,
            fax: PropTypes.string,
            email: PropTypes.string,
            table: PropTypes.shape({
              head: PropTypes.string,
              rows: PropTypes.arrayOf(
                PropTypes.shape({
                  key: PropTypes.string,
                  value: PropTypes.string,
                  tooltip: PropTypes.string,
                })
              ),
            }),
          })
        ),
      ]),
    })
  ),
}

export default Facts
